module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAh0lEQVQ4y2NgGBTgkoDJf3Iw9Q1gqLPCwFqTozDEiDLAdWH+/1df3v+v2zf7P2+ry3/WBjviDeBsdvz/9tvH/7vunMLqKoIGgJwNAr1Hl5NnAMgFzz+/+X/++a3/zA025IWB/bzs/08+vvq/7tqB/+azUv7zt7qSZgAMC7V7EO+CgUtIQxsAAI11PAFnoiEOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MV.png
// module id = 1218
// module chunks = 0